import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, Navigate } from 'react-router-dom';
import Header from 'components/Header';
import Footer from 'pages/home/Footer';
import { ROUTES } from 'shared/constants/routes';
import LINKS from 'layout/data';
import { Container, Body } from 'styles/layout';

const AuthLayout = () => {
  const auth = useSelector((state) => state?.auth);

  if (!auth.authenticated) {
    return <Navigate to={ROUTES.HOME.LINK} replace />;
  }

  return (
    <Container>
      <Header />
      <Body>
        <Outlet />
      </Body>
      <Footer isHomePage={false} links={LINKS} />
    </Container>
  );
};

export default AuthLayout;
